import logoSrc from "@/assets/favicon_io/android-chrome-192x192.png";
import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { Loader } from "@devhop/ui";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const BRAND_BG = "#001c3d"; // Midnight Navy

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div
        className="flex min-h-svh w-full items-center justify-center"
        style={{ background: BRAND_BG }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex min-h-svh w-full flex-col lg:flex-row">
      {/* Left: Brand panel — Midnight Navy, Safe Zone รอบโลโก้ */}
      <div
        className="flex flex-1 flex-col items-center justify-center px-6 py-12 lg:py-16"
        style={{ backgroundColor: BRAND_BG }}
      >
        <div className="flex w-full max-w-sm flex-col items-center gap-8 text-center">
          {/* Logo + Safe Zone (ระยะห่างรอบโลโก้ ≥ ความสูงตัว P) */}
          <div
            className="flex items-center justify-center rounded-2xl p-6"
            aria-hidden
          >
            <img
              src={logoSrc}
              alt="PARTZYNC"
              width={96}
              height={96}
              className="h-24 w-24 object-contain drop-shadow-sm"
            />
          </div>
          <div className="space-y-2">
            <h1 className="font-bold font-heading text-2xl text-white tracking-tight sm:text-3xl">
              PARTZYNC
            </h1>
            <p className="font-heading font-semibold text-lg text-primary tracking-wide">
              Merchant POS
            </p>
            <p className="mt-3 font-sans text-sm text-white/80 leading-relaxed">
              ເຊື່ອມຕໍ່ອາໄຫຼ່ ວ່ອງໄວທຸກງານສ້ອມແປງ
            </p>
          </div>
        </div>
      </div>

      {/* Right: Form area — พื้นขาว/ card */}
      <div className="flex w-full flex-1 flex-col items-center justify-center bg-background px-4 py-10 sm:px-6 lg:max-w-md lg:flex-none lg:py-16">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
